import { render, staticRenderFns } from "./Adressbook.vue?vue&type=template&id=00a4616b&"
import script from "./Adressbook.vue?vue&type=script&lang=ts&"
export * from "./Adressbook.vue?vue&type=script&lang=ts&"
import style0 from "./Adressbook.vue?vue&type=style&index=0&id=00a4616b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports